import {CostType} from "./cost-type";
import { Currency } from "./currency";
import { Ownership } from "./ownership";

export class Cost {
  public id: string;
  public name: string;
  public costType: CostType;
  public currencyId: string;
  public additionalInformation: string;
  public jsonDeterminants: string;
  public sortOrder: number;
  public ownership: Ownership;
  public currency: Currency;
  public recipientAccounts: string;
}
